import { Amplify } from 'aws-amplify'
import resources from './resources'

// eslint-disable-next-line
async function getResponse(
  resource: string,
  method = 'GET',
  data: any = undefined,
  useAuth = true,
) {
  const userSession = await Amplify.Auth.currentSession()
  const token = userSession.getAccessToken().getJwtToken()
  const response = await fetch(`${resources.api_base_url}/${resource}`, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${token}`,
    },
    body: data ? JSON.stringify(data) : undefined,
  })
  return response
}

export async function get<R>(resource: string) {
  const response = await getResponse(resource, undefined, undefined, undefined)

  if (response.ok) {
    return (await response.json()) as Promise<R>
  } else {
    return Promise.reject<R>(response.status)
  }
}

export async function getBlob(resource: string) {
  const response = await getResponse(resource, undefined, undefined, undefined)

  if (response.ok) {
    return response.blob()
  } else {
    return Promise.reject<Blob>(response.status)
  }
}

// eslint-disable-next-line
export async function post<R>(resource: string, data: any) {
  const response = await getResponse(resource, 'POST', data, true)

  if (response.ok && response.status !== 204) {
    return (await response.json()) as Promise<R>
  } else if (response.ok) {
    return Promise.resolve(undefined)
  } else {
    return Promise.reject<R>(response.status)
  }
}

// eslint-disable-next-line
export async function put<R>(resource: string, data: any) {
  const response = await getResponse(resource, 'PUT', data, true)

  if (response.ok && response.status !== 204) {
    return (await response.json()) as Promise<R>
  } else if (response.ok) {
    return Promise.resolve(undefined)
  } else {
    return Promise.reject<R>(response.status)
  }
}
